import { Link } from '@dbt-labs/sourdough';

import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
import { parseUniqueId } from '@/typings/parseUniqueId';
import { ColumnErrorPanelHeader } from './ColumnErrorPanelHeader';

export type ColumnErrorPanelContentsProps = {
  accountId: number;
  projectId: number;
  modelUniqueId: string;
  error: string | undefined | null;
  errorCategory: string | undefined | null;
};

// Should we refactor ColumnPanelContents to handle the error case?
export const ColumnErrorPanelContents: React.FC<ColumnErrorPanelContentsProps> = ({
  accountId,
  projectId,
  modelUniqueId,
  error,
  errorCategory,
}) => {
  const getResourceLink = useLinkToExplorer('resourceDetails');
  const { environmentType: environmentName } = useUrlProjectParams();
  if (error === undefined || errorCategory === undefined) return null;
  const parsedNodeUniqueId = parseUniqueId(modelUniqueId);
  const resourceLink = getResourceLink({
    accountId,
    projectId,
    environmentType: environmentName,
    dbtUniqueId: modelUniqueId,
  });

  return (
    <div
      className="h-full overflow-y-auto overflow-x-hidden"
      data-testid="column-error-panel"
    >
      {/* need to make sure we're using the same color for both header and details */}
      <ColumnErrorPanelHeader errorCategory={errorCategory} />
      <div className="m-4 space-y-6">
        <div className="space-y-2">
          <div className=" text-fgDecorative">Error Description</div>
          <div className="w-full text-fgMain" data-testid="column-error-panel-details">
            {error}
          </div>
        </div>
        <div className="space-y-2">
          <div className="text-fgDecorative">Model</div>
          <Link className="block truncate" isInternal to={resourceLink}>
            {parsedNodeUniqueId.remainder}
          </Link>
        </div>
      </div>
    </div>
  );
};
